var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendaroutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83333 7.66675H5.5V9.33342H3.83333V7.66675ZM3.83333 11.0001H5.5V12.6667H3.83333V11.0001ZM7.16667 7.66675H8.83333V9.33342H7.16667V7.66675ZM7.16667 11.0001H8.83333V12.6667H7.16667V11.0001ZM10.5 7.66675H12.1667V9.33342H10.5V7.66675ZM10.5 11.0001H12.1667V12.6667H10.5V11.0001Z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16667 16.8334H13.8333C14.7525 16.8334 15.5 16.0859 15.5 15.1667V3.50008C15.5 2.58091 14.7525 1.83341 13.8333 1.83341H12.1667V0.166748H10.5V1.83341H5.5V0.166748H3.83333V1.83341H2.16667C1.2475 1.83341 0.5 2.58091 0.5 3.50008V15.1667C0.5 16.0859 1.2475 16.8334 2.16667 16.8334ZM13.8333 5.16675L13.8342 15.1667H2.16667V5.16675H13.8333Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendaroutline);
export default __webpack_public_path__ + "static/media/calendar.outline.937ff80284205a869e4e4bb3cd43b14a.svg";
export { ForwardRef as ReactComponent };